import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();

  React.useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect(); // Redirect to login if not authenticated
    }
  }, [isAuthenticated, inProgress, instance]);

  if (
    inProgress === InteractionStatus.Startup ||
    inProgress === InteractionStatus.HandleRedirect
  ) {
    return <div>Loading...</div>; // Show a loading state during authentication
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />; // Redirect unauthenticated users
  }

  return children;
};

export default ProtectedRoute;
